import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { SiteVisitService } from '@app/services/site-visit.service';
import { ExternalOrgUserViewModel, SiteVisitViewModel } from '@app/models';
import { NotificationService, UserService } from '@app/services';
import { ExternalOrgService } from '@app/services/external-org.service';
import { Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { AmbasssadorListingCardComponent } from '../../../../common-components/ambasssador-listing-card/ambasssador-listing-card.component';
import { SpinnerComponent } from '../../../../common-components/spinner/spinner.component';


/**
 * A component that schedules a site visit for someone other than the current user.
 * Used by OA Admins to book site visits for Ambassadors and other OA Admin-level users.
 */
/**
 * TODO: Possible Remove
 * I ended up going a different route, but keeping this in case we need a workflow-step style approach
 */
@Component({
    selector: "schedule-other-site-visit",
    templateUrl: "./schedule-other-site-visit.component.html",
    styleUrls: ["./schedule-other-site-visit.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent, AmbasssadorListingCardComponent, FormsModule, RouterLink]
})
export class ScheduleOtherSiteVisitComponent implements OnInit, OnDestroy {
  private readonly _componentName = 'ScheduleOtherSiteVisitComponent';
  public externalAccounts: ExternalOrgUserViewModel[];
  private _siteVisit: SiteVisitViewModel;

  public selectedAccount: ExternalOrgUserViewModel = null;

  public loading = false;

  public siteVisit$: Subscription;

  public routeParam$: Subscription;

  constructor(
    private notify: NotificationService,
    private route: ActivatedRoute,

    private userService: UserService,
    private exOrgService: ExternalOrgService,
    private siteVisitService: SiteVisitService
  ) {
    console.log(`${this._componentName}.CTOR()`);

    this.routeParam$ = this.route.parent.paramMap.subscribe(
      (pm) => {
        console.log(`${this._componentName} subscription pm=`, pm);

        if (pm.has('id') && !this.siteVisit) {
          const id = +pm.get('id');

          this.retrieveSiteVisit(id);
        }
      },
      (err) => {
        console.error(err);
        
        this.notify.error('A subscription error occured', null);
      }
    );

    this.siteVisit$ = this.siteVisitService.siteVisit.subscribe(
      (result) => {
        console.log(`${this._componentName} subscription result=`, result);

        this.siteVisit = result;
      },
      (err) => {
        console.error(err);
        
        this.notify.error('A subscription error occured', null);
      }
    );
  }

  ngOnInit() {
    console.log(`${this._componentName}.ngOnInit()`);

    this.retrieveExternalAccounts();
  }

  private retrieveSiteVisit(siteVisitId: number) {
    if (siteVisitId) {
      this.siteVisitService.get(siteVisitId).subscribe(
        (result) => {
          this.siteVisit = result;
        },
        (err) => {
          console.error(err);
          
          this.notify.error('A subscription error occured', null);
        }
      );
    }
  }

  /**
   * Called once, before the instance is destroyed.
   */
  ngOnDestroy(): void {
    if (this.siteVisit$) {
      this.siteVisit$.unsubscribe();
    }

    if (this.routeParam$) {
      this.routeParam$.unsubscribe();
    }
  }

  public get siteVisit(): SiteVisitViewModel {
    return this._siteVisit;
  }
  public set siteVisit(v: SiteVisitViewModel) {
    console.log(`${this._componentName}.siteVisit - set v=`, v);
    this._siteVisit = v;
  }

  private retrieveExternalAccounts() {
    this.loading = true;

    this.exOrgService.getExOrgAccounts('OAA').subscribe(
      (results) => {
        console.log(`${this._componentName} subscription results=`, results);

        this.externalAccounts = results;
      },
      (err) => {
        console.error(err);
        
        this.notify.error('A subscription error occured', null);
      },
      () => {
        this.loading = false;
      }
    );
  }

  public get isAdmin(): boolean {
    return this.userService.isAdmin;
  }

  public get scheduleEnabled(): boolean {
    let b = false;

    if (this.selectedAccount && this.siteVisit) {
      return true;
    }
  }

  public onScheduleClick() {
    console.log(`${this._componentName}.onScheduleClick()`);
  }
}
